export default __webpack_public_path__ + "static/media/waves.f8b24a9d.png";